import styled from 'styled-components'

export const Wrapper = styled.div`
  background-color: var(--gray-200);
  border-radius: var(--border-radius);
  overflow: hidden;
  position: relative;
  height: 19rem;

  img {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .play-icon {
    color: var(--white);
    opacity: 0.5;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
  }

  &::before {
    content: '';
    background: rgba(0, 0, 0, 0.3);
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
  }
`

Wrapper.displayName = 'Wrapper'
